import m from "../../fonts/es2015/notosans-kr";
window.am4fonts_notosans_kr = m;


//////////////////
// WEBPACK FOOTER
// ./fonts/notosans-kr.js
// module id = null
// module chunks = 